import axios from 'axios';

const apiClube = axios.create({
  baseURL: process.env.REACT_APP_API_CLUBE_URL,
});

export default apiClube;
